var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-wrap" }, [
    _c(
      "div",
      { staticStyle: { width: "100%" } },
      [
        !_vm.isLogged
          ? _c(
              "el-row",
              {
                attrs: {
                  gutter: 20,
                  type: "flex",
                  justify: "space-between",
                  align: "bottom",
                },
              },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("auth.register.title")))]),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticClass: "text-right", attrs: { span: 12 } },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "blacklink",
                        attrs: { to: _vm.loginLink },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("auth.login.title")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "el-row",
              {
                attrs: {
                  gutter: 20,
                  type: "flex",
                  justify: "space-between",
                  align: "bottom",
                },
              },
              [
                _c("el-col", [
                  _c("h2", [
                    _vm._v("Hello" + _vm._s(_vm.currentUserName) + "!"),
                  ]),
                ]),
              ],
              1
            ),
        _vm._v(" "),
        _c("register-form", {
          attrs: { loading: _vm.loading, errors: _vm.authErrors },
          on: { submit: _vm.onSubmit },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }